import { useEffect, useRef, useState } from "react";
import fallbackImg from "../../../../public/images/fallback.jpg";
import { useMemo } from "react";
import { GetAlbumDetailsQuery } from "@src/@types/api.d";

type Props = {
  albumDetailsData: GetAlbumDetailsQuery;
};

const Quotes = ({ albumDetailsData }: Props) => {
  const text =
    "My heart is yours to hold and cherish for the rest of our days.";
  const [displayed, setDisplayed] = useState("");
  const [typing, setTyping] = useState(true);
  const [inView, setInView] = useState(false);
  const [randomUrl, setRandomUrl] = useState<string | null>(null);
  const containerRef = useRef(null);

  const mediaData = useMemo(
    () => albumDetailsData?.getMedia || [],
    [albumDetailsData]
  );
  const isValidImageUrl = (img: any): boolean =>
    img &&
    img.meta &&
    typeof img.meta.s3_url === "string" &&
    img.meta.s3_url.trim() !== "" &&
    img.meta.s3_url.startsWith("http");

  useEffect(() => {
    const validImages = mediaData.filter(isValidImageUrl);
    if (validImages.length > 0) {
      const random =
        validImages[Math.floor(Math.random() * validImages.length)];
      if (random && random.meta && random.meta.s3_url) {
        setRandomUrl(random.meta.s3_url);
      } else {
        setRandomUrl(
          typeof fallbackImg === "string" ? fallbackImg : fallbackImg.src
        );
      }
    } else {
      setRandomUrl(
        typeof fallbackImg === "string" ? fallbackImg : fallbackImg.src
      );
    }
  }, [mediaData]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !inView) {
          setInView(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [inView]);

  useEffect(() => {
    if (!inView) return;

    setDisplayed("");
    setTyping(true);
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed((prev) => prev + text[i]);
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        setTyping(false);
      }
    }, 30);
    return () => clearInterval(interval);
  }, [inView]);

  return (
    <div className="bg-[#FEFEFE] h-screen border-b border-[#4A2C47] flex flex-col sm:flex-row justify-center z-60">
      <div
        ref={containerRef}
        className="h-2/5 sm:h-full sm:w-1/2 flex justify-center items-center relative px-8 overflow-hidden"
      >
        <div className="flex flex-col justify-center items-center w-full lg:w-3/4">
          <h3 className="font-dacing font-semibold lg:font-light leading-snug text-4xl lg:text-[80px] text-center text-[#4A2C47]">
            {displayed}
            {typing && <span className="animate-pulse">|</span>}
          </h3>
        </div>
      </div>
      <div
        className="h-3/5 sm:h-full sm:w-1/2"
        style={{
          backgroundImage: randomUrl ? `url('${randomUrl}')` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "top",
          backgroundRepeat: "no-repeat",
        }}
      ></div>
    </div>
  );
};

export default Quotes;
